<template>
  <div class="content home-wrapper">
    <div class="content-inner">
      <h1 class="title">
        <img height="100" src="../../../../assets/images/kundan-logo.png">
      </h1>
      <div class="full-w flex-column">
        <span>
          {{ message }}
        </span>
        <router-link class="buttons_login" :to="{ name: 'auth.login'}"><el-button type="primary" style="color:black">{{ $t('button.enter') }}</el-button></router-link><br/><br/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      message() {
        return this.$route.query.status && this.$route.query.status === 'success' ?
        this.$t('static.unsubscribed.success') :
        this.$t('static.unsubscribed.error');
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .content-inner
    padding 5%
    span
      text-align center
      font-size 1.5rem
      margin-bottom 3rem
</style>



// WEBPACK FOOTER //
// unsubscribed.vue?0403e3bf